<template>
    <div class="videoChapter"> 
    目录
    <el-scrollbar max-height="400px">
    <div class="demo-collapse videoChapter" >
      <el-collapse v-model="activeNames" @change="handleChange">
        <el-collapse-item
          :title="chapter.chapterName"
          :name="chapter.chapterId"
          v-for="chapter in chapters"
          :key="chapter.chapterId">
          <div
            v-for="data in chapter.data"
            :key="data.dataId"
            @click="changeVideo(data.dataLink)"
          >
            <div
              class="videoBorder videoBorderIng"
              v-if="data.dataType == 0 && data.dataLink == videoId"
              :title="data.dataName"
            >
              <el-icon><Film /></el-icon>
              {{ data.dataName.substr(0, 18) }}
            
            
              <div class="Playing">
                <el-progress :width="35" type="circle" :percentage="100" status="success" v-if="data.hasRead == 100"/>
                <el-progress  :width="35" type="circle" :percentage="33" color="#f56c6c" v-if="data.hasRead == 33" />
                <el-progress  :width="30" type="circle"  :percentage="67" v-if="data.hasRead == 67" />
                <el-progress  :width="30" type="circle" :percentage="0" color="#6f7ad3" v-if="data.hasRead == null"/>
              </div>
              <div class="Playing">
                <el-icon><VideoPlay /></el-icon>正在播放
              </div>
          </div>
            <div
              class="videoBorder videoBorderOther"
              v-if="data.dataType == 0 && data.dataLink != videoId"
              :title="data.dataName"
            >
              <el-icon><Film /></el-icon>
              {{ data.dataName.substr(0, 18) }}

              <div class="Playing">
                <el-progress :width="30" type="circle" :percentage="100" status="success" v-if="data.hasRead == 100"/>
                <el-progress  :width="30" type="circle" :percentage="33" color="#f56c6c" v-if="data.hasRead == 33" />
                <el-progress  :width="30" type="circle"  :percentage="67" v-if="data.hasRead == 67" />
                <el-progress  :width="30" type="circle" :percentage="0" color="#6f7ad3" v-if="data.hasRead == null"/>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    </el-scrollbar>
  </div>

</template>

<script setup>
import { ref, onMounted, defineExpose } from "vue";
import $ from "jquery";
import { useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import router from "@/router";

const activeNames = ref();
const Route = useRoute();
const chapters = ref();
const courseId = ref("");
const videoId = ref("");


onMounted(() => {
  courseId.value = Route.params.courseId;
  videoId.value = Route.params.videoId;
  pullChapterList();

  changeActiceChapter();
});

// 拉取章节列表
const pullChapterList = () => {
  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/chapter/getChapterList",
    data: {
      courseId: courseId.value,
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
      console.log(resp.data);
      if (resp.code == "200") {
        chapters.value = resp.data;
      } else {
        ElMessage({
          type: "error",
          message: "拉取章节失败",
        });
      }
    },
    error() {
      ElMessage({
        type: "error",
        message: "拉取章节失败",
      });
    },
  });
};

const changeVideo = (vid) => {
  router.push({
    name: "video",
    params: { courseId: courseId.value, videoId: vid },
  });

  setTimeout(() => {
    location.reload();
  }, 200);
};

const changeActiceChapter = () => {
  setTimeout(() => {
    for (let chapter of chapters.value) {
      for (let data of chapter.data) {
        if (data.dataLink == videoId.value) {
          activeNames.value = chapter.chapterId;
          return;
        }
      }
    }
  }, 200);
};

defineExpose({ pullChapterList });
</script>

<style scoped>
.videoBorderIng {
  padding: 5px;
  border-radius: 5px;
  border: 1px solid rgba(116, 248, 116, 0.993);
  background-color: rgba(116, 248, 116, 0.562);
  margin: 5px;
  font-size: larger;
  font-weight: 300;
}

.videoBorderOther {
  padding: 5px;
  border-radius: 5px;
  border: 1px solid rgb(134, 134, 134);
  margin: 5px;
  font-size: larger;
  font-weight: 300;
}

.videoBorder:hover {
  cursor: pointer;
  transition: 500ms;
  background-color: rgba(66, 192, 250, 0.267);
}

.Playing {
  float: right;
  font-size: x-small;
  color: rgba(0, 102, 255, 0.767);
  margin-right: 5px;
}

.videoChapter {
  background-color: rgba(196, 196, 196, 0.644);
}


</style>